<template>
<div class="csNewDL">
  <LEFT></LEFT>
  <Right></Right>
</div>
</template>

<script>
export default {
  name: "csNewDL",
  components: {
    LEFT: () => import('./left'),
    Right: () => import('./rights'),

  }
}
</script>

<style scoped lang="scss">
.csNewDL {
  width: 100vw;
  height: 87vh;
  overflow: hidden;
  background: rgba(242, 244, 247, 1);
  display: flex;
}
</style>
